import type { LocaleId } from "@dawn/i18n";

export interface DawnSiteState {
  locale: LocaleId;
  playLabel: string;
}

declare global {
  interface Window {
    __DAWN_SITE__?: DawnSiteState;
  }
}

export function publishSiteState(locale: LocaleId, playLabel: string): void {
  window.__DAWN_SITE__ = { locale, playLabel };
}

export function clearSiteState(): void {
  delete window.__DAWN_SITE__;
}
